import { registerToolboxCode } from "../utils";

registerToolboxCode("tmlf1", "minis:line_follower:l1");
registerToolboxCode("tmlf2", "minis:line_follower:l2");